import { SearchIcon } from 'lucide-react'
import { ItemWrapper } from '../ItemWrapper'

type AllResultsButtonProps = {
  onAllResultsClick: () => void
}

export const AllResultsButton = ({
  onAllResultsClick,
}: AllResultsButtonProps) => (
  <ItemWrapper onClick={onAllResultsClick} className="mt-xxxs ">
    <div className="flex h-10 w-10 items-center justify-center rounded-full bg-gray-100">
      <SearchIcon
        size={20}
        className="text-gray-500"
        data-testid="search-icon"
      />
    </div>
    All search results
  </ItemWrapper>
)
